import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_world",
  "use": "icon-project_world-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_world\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><circle cx=\"14\" cy=\"14\" r=\"13\" /><ellipse cx=\"14\" cy=\"14\" rx=\"5\" ry=\"13\" /><path stroke-linecap=\"round\" d=\"M2 17.5h24M2 10.5h24\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol